import * as React from "react"
import { Linking, Platform } from "react-native"
import { Text} from "react-native"

export interface LinkTextProps {
    text: string,
    url: string
}

const openLink = (link:string) => {
    if(Platform.OS === "web"){
        window.open(link, '_blank');
    }else{
        Linking.openURL(link)
    }
} 

export function LinkText(props:LinkTextProps){
    return <Text style={{color: 'blue'}} numberOfLines={1} onPress={() => openLink(props.url)}>{props.text}</Text>
}